import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Latihan from "./Latihan";
import reportWebVitals from "./reportWebVitals";
import reactDom from "react-dom";

ReactDOM.render(
  <React.StrictMode>
    <Latihan />
  </React.StrictMode>,
  document.getElementById("test")
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
